import { useContext, useEffect } from "react";
import Context from "../../Context";

const useSendLog = () => {
  const context = useContext(Context);

  const sendLog = () => {
    context.ApiDriver.sendLog(
      {
        action: "PAGE_VISIT",
        sub_action: document.location.pathname,
        main_value: "null",
        context: "site",
        info: "{}",
      },
      response => {
        console.log("log sent");
      },
      error => {
        console.log(error);
      },
    );
  };

  useEffect(sendLog, [document.location.pathname]);
};

export default useSendLog;
